import { render, staticRenderFns } from "./BackofficeFields.vue?vue&type=template&id=5427e72b&scoped=true"
import script from "./BackofficeFields.vue?vue&type=script&lang=js"
export * from "./BackofficeFields.vue?vue&type=script&lang=js"
import style0 from "./BackofficeFields.vue?vue&type=style&index=0&id=5427e72b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427e72b",
  null
  
)

export default component.exports